import { Link } from "react-router-dom";
import NetworkGraph from "../../components/NetworkGraph";
import Reveal from "../../components/Reveal";
import {
  IconGlobe, IconCloud, IconDatabase, IconChat, IconShield, IconChart, IconPrinter,
} from "../../components/Icons";

const PRODUCTS = [
  {
    accent: "#1A6CF6",
    bg: "rgba(26,108,246,.12)",
    Icon: IconGlobe,
    tag: "Cloud Hosting · SaaS / IaaS",
    title: (
      <>
        sepol<span style={{ color: "#1A6CF6" }}>HOSTING</span>
      </>
    ),
    desc: "Hospedagem web profissional em nuvem. E-mail corporativo, hospedagem de sites e VPS — infraestrutura estável com suporte da sepolTECH incluído.",
    chips: ["E-mail Corporativo", "Hospedagem de Sites", "VPS"],
    href: "https://sepolhost.com.br/",
  },
  {
    accent: "#0091FF",
    bg: "rgba(0,145,255,.12)",
    Icon: IconCloud,
    tag: "Private Cloud · Self-hosted",
    title: (
      <>
        sepol<span style={{ color: "#0091FF" }}>DRIVE</span>
      </>
    ),
    desc: "Nuvem privada com Nextcloud. Seus dados no seu servidor — privacidade e controle totais, sem o Google ou Microsoft lendo seus arquivos. Alternativa profissional ao OneDrive e Google Drive.",
    chips: ["Nuvem Privada", "Colaboração", "Compartilhamento"],
    href: "/produtos/sepol-drive",
  },
  {
    accent: "#3ABEFF",
    bg: "rgba(58,190,255,.12)",
    Icon: IconDatabase,
    tag: "BaaS · Backup-as-a-Service",
    title: (
      <>
        sepol<span style={{ color: "#3ABEFF" }}>BACKUP</span>
      </>
    ),
    desc: "Backup gerenciado em nuvem. Acontece automaticamente, sem intervenção humana — você não precisa lembrar de nada. A sepolTECH gerencia, monitora e valida seus backups.",
    chips: ["Automático", "Gerenciado", "Cloud Backup"],
    href: "/produtos/sepol-backup",
  },
  {
    accent: "#00C2A0",
    bg: "rgba(0,194,160,.12)",
    Icon: IconChat,
    tag: "CX Platform · Omnichannel",
    title: (
      <>
        sepol<span style={{ color: "#00C2A0" }}>CHAT</span>
      </>
    ),
    desc: "Plataforma omnichannel de atendimento ao cliente. WhatsApp e múltiplos canais em uma única tela para toda a equipe — sem caos, com histórico completo e relatórios de atendimento.",
    chips: ["WhatsApp", "Multiatendimento", "Omnichannel"],
    href: "/produtos/sepol-chat",
  },
  {
    accent: "#7B3FF2",
    bg: "rgba(123,63,242,.12)",
    Icon: IconShield,
    tag: "EPP + EDR · Bitdefender GravityZone",
    title: (
      <>
        sepol<span style={{ color: "#7B3FF2" }}>SECURITY</span>
      </>
    ),
    desc: "Segurança corporativa de endpoint com Bitdefender GravityZone gerenciado pela sepolTECH. EPP + EDR integrado — proteção avançada com detecção e resposta a ameaças em tempo real.",
    chips: ["EPP", "EDR", "Bitdefender", "Gerenciado"],
    href: "/produtos/sepol-security",
  },
  {
    accent: "#22C55E",
    bg: "rgba(34,197,94,.12)",
    Icon: IconChart,
    tag: "SaaS ERP · Bruning Sistemas",
    title: (
      <>
        <span style={{ color: "#22C55E" }}>ERP</span> Bruning
      </>
    ),
    desc: "Sistema de Gestão Empresarial integrado em nuvem. A sepolTECH realiza a implantação, treinamento e suporte contínuo — você tem todo o poder de um ERP com o apoio de quem conhece TI.",
    chips: ["ERP em Nuvem", "Implantação", "Suporte Incluído"],
    href: "/produtos/erp",
  },
  {
    accent: "#E8530A",
    bg: "rgba(232,83,10,.12)",
    Icon: IconPrinter,
    tag: "Outsourcing · Locação de Equipamentos",
    title: (
      <>
        Outsourcing <span style={{ color: "#E8530A" }}>&amp;</span> Locação de
        Impressoras
      </>
    ),
    desc: "Terceirize sua TI e impressão com mensalidade fixa. A sepolTECH fornece os equipamentos, cuida da manutenção, toner e suporte — você elimina custos imprevistos e foca no seu negócio.",
    chips: ["Outsourcing de TI", "Locação de Impressoras", "Toner Incluso"],
    href: "/produtos/outsourcing-locacao",
  },
];

export default function Produtos() {
  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <span>Produtos</span>
          </div>
          <div className="tag animate-up animate-up--d1">Plataformas em nuvem</div>
          <h1
            className="section-title animate-up animate-up--d2"
            style={{ fontSize: "clamp(36px,5vw,56px)", maxWidth: "700px" }}
          >
            O que a sepolTECH
            <br />
            <span className="text-blue">entrega para você usar</span>
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "18px",
              color: "var(--text-secondary)",
              maxWidth: "580px",
              lineHeight: "1.7",
              marginTop: "16px",
            }}
          >
            Plataformas e softwares em nuvem com assinatura mensal — todos
            gerenciados, suportados e monitorados pela sepolTECH. Você usa,
            nós cuidamos.
          </p>
        </div>
      </section>

      {/* ═══════════════ LISTA DE PRODUTOS ═══════════════ */}
      <section className="section">
        <div className="container">
          <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
            {PRODUCTS.map((product, i) => (
              <Reveal
                as={Link}
                to={product.href}
                className="card card-list-item"
                style={{ "--accent": product.accent }}
                delay={i * 0.05}
                key={product.tag}
              >
                <div
                  className="card__icon"
                  style={{
                    width: "80px",
                    height: "80px",
                    background: product.bg,
                    color: product.accent,
                    marginBottom: 0,
                  }}
                >
                  <product.Icon style={{ width: "34px", height: "34px" }} />
                </div>
                <div>
                  <div
                    className="card__tag"
                    style={{ color: product.accent, marginBottom: "8px" }}
                  >
                    {product.tag}
                  </div>
                  <h3
                    style={{
                      fontFamily: "var(--font-display)",
                      fontSize: "24px",
                      fontWeight: 700,
                      marginBottom: "8px",
                      color: "var(--text-primary)",
                    }}
                  >
                    {product.title}
                  </h3>
                  <p
                    style={{
                      fontSize: "15px",
                      color: "var(--text-secondary)",
                      lineHeight: "1.6",
                      maxWidth: "600px",
                    }}
                  >
                    {product.desc}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      marginTop: "12px",
                      flexWrap: "wrap",
                    }}
                  >
                    {product.chips.map((chip) => (
                      <span
                        key={chip}
                        style={{
                          fontFamily: "var(--font-mono)",
                          fontSize: "11px",
                          background: product.bg,
                          color: product.accent,
                          padding: "4px 10px",
                          borderRadius: "100px",
                          border: `1px solid ${product.accent}33`,
                        }}
                      >
                        {chip}
                      </span>
                    ))}
                  </div>
                </div>
                <span
                  className="card-list-arrow"
                  style={{
                    color: product.accent,
                    fontWeight: 700,
                    fontSize: "20px",
                    flexShrink: 0,
                  }}
                >
                  →
                </span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ CTA ═══════════════ */}
      <section className="section section--alt">
        <div className="container">
          <Reveal className="cta-banner">
            <h2 className="cta-banner__title">Não sabe por onde começar?</h2>
            <p className="cta-banner__sub">
              Nossos especialistas avaliam sua empresa e indicam os produtos
              certos para a sua realidade.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">
                Falar com especialista →
              </Link>
              <Link to="/faq" className="btn btn-outline">
                Ver FAQ
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
